import React, { useEffect, useRef, useState } from 'react';

// locales
import { useTranslation } from 'react-i18next';
import { translations } from '../../../locales/i18n';

// icons
import { ReactComponent as AddToCalendar } from '../../../assets/icons/add_to_calendar_icon.svg';

// styles
import { ATCButtonLink } from './styles';

export function ATCButton(args) {
  const [active, setActive] = useState(false);

  function wrapHandleClick(event) {
    setActive(!active);
    args.onClick(event);
  }

  return (
    <ATCButtonLink
      onClick={wrapHandleClick}
      to="/"
      className={active ? 'ATCButton activeBtn' : 'ATCButton'}
    >
      <AddToCalendar />
      <span>{args.children}</span>
    </ATCButtonLink>
  );
}

export default ATCButton;
